/* Core */
import React from "react";

const Spinner = () => {
  return (
    <div className="Spinner" />
  )
}

export default Spinner;
